import { useLocation } from 'react-router-dom';

import { useShowIntro } from '../hooks/use-show-intro';
import { useIsUserFromIndeed } from '../hooks/use-is-user-from-indeed';

import { route, RoutePath } from './routes';

type StepConfig = {
  shouldShowProgressBar: boolean;
};

const stepperConfig: Partial<Record<RoutePath, StepConfig>> = {
  feat: {
    shouldShowProgressBar: false,
  },
  root: {
    shouldShowProgressBar: false,
  },
  register: {
    shouldShowProgressBar: true,
  },
  pro_status: {
    shouldShowProgressBar: true,
  },
  additional_information: {
    shouldShowProgressBar: true,
  },
  appointment: {
    shouldShowProgressBar: true,
  },
};

export const useStepper = () => {
  const isUserFromIndeed = useIsUserFromIndeed();

  const STEPS: RoutePath[] = [
    ...(isUserFromIndeed ? [] : ['root' as RoutePath]),
    'register',
    'pro_status',
    'additional_information',
    'appointment',
  ];

  const location = useLocation();
  const current = STEPS.findIndex((step) => route(step) === location.pathname);
  const next = current + 1;
  const previous = current - 1;

  useShowIntro(current === 0);

  return {
    current,
    currentStep: STEPS[current],
    total: STEPS.length,
    nextRoute: STEPS[next],
    previousRoute: STEPS[previous],
    stepConfig: stepperConfig[STEPS[current]],
  };
};
